import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
/**
 * 标签输入框组件，继承Base
 * @module $ui/components/my-tag-input
 */

import TagInput from '../common/TagInput';
import Base from '../Base';
export default {
  name: 'MyTagInput',
  mixins: [Base],
  components: {
    TagInput: TagInput
  },
  props: {
    value: Array
  },
  methods: {
    getDefaultValue: function getDefaultValue() {
      return [];
    },
    handleChange: function handleChange(val) {
      if (val && val.length) {
        this.clearValidate();
      }
      this.$emit('change', val);
    }
  },
  computed: {
    inputSize: function inputSize() {
      if (this.size) return this.size;
      if (this.myForm) {
        return this.myForm.$attrs.size || '';
      }
      return '';
    }
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var vnode = h(TagInput, {
      "ref": 'comp',
      "props": _objectSpread({}, _objectSpread(_objectSpread({}, this.innerProps), {}, {
        size: this.inputSize
      })),
      "on": _objectSpread({}, _objectSpread(_objectSpread({}, this.$listeners), {}, {
        change: this.handleChange
      })),
      "attrs": {
        "size": this.inputSize
      },
      "model": {
        value: _this.fieldValue,
        callback: function callback($$v) {
          _this.fieldValue = $$v;
        }
      }
    });
    return this.renderComponent(vnode);
  },
  mounted: function mounted() {
    this.extendMethods(this.$refs.comp, ['focus', 'blur']);
  }
};